import React, { useState, Fragment } from 'react';
import { useTranslate, ReferenceField } from 'react-admin';
import Grid from '@material-ui/core/Grid';
import { Solution } from '~/types';
import PIAvailabilityEdit from './PIAvailabilityEdit';
import { Drawer, EditButton, TextField, ChipField } from '~/components';
import { TextField as RaTextField } from '~/components/ra';
import { useHandbooksQuery } from '~/hooks/useHandbook';
import { isEmpty } from 'lodash';
import { Longdash } from '~/utils';
import { PIAvailability } from '~/types/solutions';

export const l = (key: string): string =>
  `resources.solutions.paymentInstrumentAvailabilityRules.${key}`;

interface Props {
  record: PIAvailability | null;
  solutionRecord: Solution;
  onClose: () => void;
  basePath?: string;
  permissions: string[];
}

const PIAvailabilityShow = (props: Props) => {
  const { record, solutionRecord, onClose, basePath, permissions } = props;
  const translate = useTranslate();
  const t = (key: string): string => translate(l(key));

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { data: handbook } = useHandbooksQuery(record?.solutionId);
  const kycLevels = handbook?.kycLevels || [];
  const kycLevel = kycLevels.find((level) => level.id === record?.kycLevel);
  const kycLevelName = kycLevel?.name;
  return (
    <Fragment>
      <PIAvailabilityEdit
        record={record}
        solutionRecord={solutionRecord}
        open={open}
        onClose={handleClose}
        closeParent={onClose}
        permissions={permissions}
      />
      <Drawer heading={t('showPaymentInstrument')} open={!!record} onClose={onClose}>
        {record && (
          <Grid container spacing={2}>
            {record.productId && (
              <Grid item xs={12}>
                <ReferenceField
                  source='productId'
                  record={record}
                  basePath={basePath}
                  reference='products'
                  link={false}
                >
                  <RaTextField source='name' label={t('paymentInstrument')} />
                </ReferenceField>
              </Grid>
            )}
            {record.externalSourceType && (
              <Grid item xs={12}>
                <TextField label={t('paymentInstrument')}>{record.externalSourceType}</TextField>
              </Grid>
            )}
            <Grid item xs={12}>
              <TextField label={t('profileKycLevel')}>{kycLevelName}</TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField label={t('allowedProfileTags')} textWrap>
                {!isEmpty(record?.allowedProfileTags)
                  ? record?.allowedProfileTags?.map((name: string, index: number) => {
                      return <ChipField label={name} key={index} />;
                    })
                  : Longdash}
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField label={t('disallowedProfileTags')} textWrap>
                {!isEmpty(record?.disallowedProfileTags)
                  ? record?.disallowedProfileTags?.map((name: string, index: number) => {
                      return <ChipField label={name} key={index} />;
                    })
                  : Longdash}
              </TextField>
            </Grid>
            <Grid item container justify='flex-end'>
              <Grid item>
                <EditButton
                  onClick={handleOpen}
                  disabled={
                    !permissions.includes('solution.paymentInstrumentAvailabilityRules.update')
                  }
                />
              </Grid>
            </Grid>
          </Grid>
        )}
      </Drawer>
    </Fragment>
  );
};

export default PIAvailabilityShow;
